import { classNameMerger } from '@breetometer/utils';
import { ImageComponent } from 'BreetComponents';

import type { IModernDropdownItemOptions } from '../../Dropdown.helpers';

const ModernItemOptions = ({ items, selectedItem, handleItemSelection, CustomItemOption }: IModernDropdownItemOptions) => (
	<>
		{items.map((item) => {
			const isSelected = !!selectedItem && selectedItem.code === item.code && selectedItem.name === item.name;

			return (
				<button
					type='button'
					key={`${item.code}_${item.name}`}
					onClick={handleItemSelection(item)}
					className={classNameMerger('modern-dropdown_option', isSelected && 'selected')}
					data-testid={`modern-option-${item.code}`}
					aria-current={isSelected ? 'true' : undefined}
					title={item.name}
					name={item.name}
				>
					{!CustomItemOption ? (
						<>
							<span className='modern-dropdown_option_name'>{item.name}</span>
							<span className='modern-dropdown_option_icon'>
								{typeof item.icon === 'string' ? (
									<ImageComponent
										src={item.icon}
										alt=''
									/>
								) : (
									(item.icon ?? null)
								)}
							</span>
						</>
					) : (
						<CustomItemOption item={item} />
					)}
				</button>
			);
		})}
	</>
);

export default ModernItemOptions;
